export const sendCustomEvent = label => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: label
  });
};
